<template>
  <span :style="{color}">
    <template v-if="showTime">
      <slot></slot>
      <span>{{ dataTime }}</span>
    </template>
  </span>
</template>

<script>
import { setInterval, clearInterval } from "timers";
export default {
  props: {
    start: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Boolean,
      default: false
    },
    checkout: {
      type: Number,
      default: 20000
    },
    startValues: {
      type: Object,
      default() {
        return { seconds: 0 };
      }
    },
    color: {
      type: String,
      default: "rgba(255, 255, 255, 0.5)"
    },
    time: {
      type: String,
      default: "00:00:00"
    }
  },
  data() {
    return {
      timer: new window.Timer(),
      dataTime: null,
      interval: null
    };
  },
  methods: {
    startTimer(val) {
      if (!val) {
        this.timer.reset();
        clearInterval(this.interval);
        return;
      }

      if (!this.startValues) return;

      this.timer.start({ startValues: this.startValues });

      clearInterval(this.interval);
      this.interval = setInterval(
        () => this.$emit("checkout-end"),
        this.checkout
      );
    },
    reset() {
      this.timer.reset();
      this.updateDataTime();
    },
    pause() {
      this.timer.pause();
      this.updateDataTime();
    },
    updateDataTime() {
      this.dataTime = this.timer.getTimeValues().toString();
    }
  },
  created() {
    this.timer = new window.Timer();
  },
  mounted() {
    this.timer.addEventListener("secondsUpdated", () => {
      if (!this.start) {
        this.timer.stop();
        return;
      }
      this.updateDataTime();
      this.$emit("seconds-updated", this.dataTime);
    });

    this.timer.addEventListener("targetAchieved", () => {
      this.$emit("target-achieved");
    });

    this.timer.addEventListener("reset", () => {
      this.$emit("reset");
    });

    this.timer.addEventListener("started", () => {
      this.$emit("started");
    });

    if (this.start) {
      this.startTimer(this.start);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  watch: {
    start: {
      immediate: true,
      handler: "startTimer"
    },
    time: {
      immediate: true,
      handler(data) {
        this.dataTime = data;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
